import { render, staticRenderFns } from "./importantBusiness.vue?vue&type=template&id=7b75a026&"
import script from "./importantBusiness.vue?vue&type=script&lang=js&"
export * from "./importantBusiness.vue?vue&type=script&lang=js&"
import style0 from "./importantBusiness.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports